import styled from 'styled-components'
import { BaseModalBackground } from 'styled-react-modal'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  align-self: center;
  margin-left: auto;

  position: relative;
`
export const InfoContainer = styled.div`
  display: flex;
  margin-right: 24px;

  cursor: pointer;
`

export const InfoDisplay = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
`

export const Name = styled.div`
  align-self: self-end;
  color: ${colors.titleStrongWhite};

  @media (max-width: 875px) {
    display: none;
  }
`

export const CompanyName = styled(Name)`
  color: ${colors.titleStrongWhite}A3;
  font-size: 12px;

  @media (max-width: 875px) {
    display: none;
  }
`

export const UserInitials = styled(Name)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: ${colors.titleStrongBlack};
  background-color: ${colors.softGray};
  height: 40px;
  width: 40px;
  margin-left: 12px;
`

export const TransparentModalBackground = styled(BaseModalBackground)`
  background-color: rgba(0, 0, 0, 0);
`

export const ContainerMenu = styled.div`
  border-radius: 25%;
`

export const ContainerLogOut = styled.div`
  height: 100px;
  width: 300px;
  position: absolute;
  opacity: 0;
  top: 70px;
  right: 20px;
  z-index: 1;

  background-color: ${colors.background};

  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  @-webkit-keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  z-index: 1000;
`
export const Title = styled.p`
  margin-left: 12px;
  color: ${colors.strongGray};
  font-family: Circular-Std;
  font-size: 14px;
  text-align: justify;
  font-weight: 700;
  white-space: nowrap;
`

export const Menu = styled.div`
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  opacity: 1;

  & > :nth-child(-n + 3) {
    border-bottom: 1px solid ${colors.softGray};
  }
`

export const ButtonContainer = styled.button`
  height: 55px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border: none;
  background-color: ${colors.background};
  color: ${colors.strongGray};
  cursor: pointer;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ExamsContainer = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  margin-right: 32px;
`
